import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import firebase from '../firebase';
import ReactApexChart from 'react-apexcharts';
import { normalizeTimezone, zonedMoment, orderMillis, calendarRange } from './restaurantTime';
import { watchRestaurantDay } from './restaurantDayRollover';
import { Line, Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { clearDashboardQueryCache, cachedQuery, getDashboardCacheTtlMs } from './dashboardQueryCache';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
const Dashboard = () => {
    const [timezone, setTimezone] = useState(null);
    const refreshInFlight = useRef(false);
    const refreshLatest = useRef(null);
    const customDateRange = useRef(false);
    const moment = (...parts) => zonedMoment(timezone || 'America/New_York', ...parts);
    const [loadingState, setLoadingState] = useState(true);
    const [loadingCount, setLoadingCount] = useState(0);
    const [loadingMap, setLoadingMap] = useState({
        cards: true,
        revenue: true,
        summary: true,
        orders: true,
        trends: true,
        avgOrders: true,
        avgItems: true,
        avgAmounts: true,
    });
    const loading = loadingState || loadingCount > 0;
    const setLoading = (value) => {
        setLoadingState(value);
        setLoadingCount((current) => value ? current + 1 : Math.max(0, current - 1));
    };
    const [lastUpdated, setLastUpdated] = useState(null);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const showInitialLoading = loading && !lastUpdated;
    const dashboardCacheTtlMs = getDashboardCacheTtlMs();
    const getRestaurantId = () => localStorage.getItem('CB_settings_ID')

    const getOrdersSnapshot = () => cachedQuery(
        `orders:${getRestaurantId()}`,
        () => firebase.firestore().collection('orders').where('restaurant_id', '==', getRestaurantId()).get(),
        dashboardCacheTtlMs
    )

    const getItemsSnapshot = () => cachedQuery(
        `items:${getRestaurantId()}`,
        () => firebase.firestore().collection('items').where('restaurant_id', '==', getRestaurantId()).get(),
        dashboardCacheTtlMs
    )

    const getProfileSnapshot = () => cachedQuery(
        `restaurant:${getRestaurantId()}`,
        () => firebase.firestore().collection('restaurants').doc(getRestaurantId()).get(),
        dashboardCacheTtlMs
    )

    const getOrderItemsSnapshot = (orderId) => cachedQuery(
        `order-items:${getRestaurantId()}:${orderId}`,
        () => firebase.firestore().collection('orders').doc(String(orderId)).collection('items').get(),
        dashboardCacheTtlMs
    )

    const formatLastUpdated = () => {
        if (!lastUpdated) {
            return 'Loading...'
        }

        const minutes = Math.max(0, Math.floor((Date.now() - lastUpdated) / 60000))

        if (minutes === 0) {
            return 'just now'
        }

        return `${minutes} min${minutes === 1 ? '' : 's'} ago`
    }

    useEffect(() => {
        if (!loading) {
            setLastUpdated(Date.now())
        }
    }, [loading])
    // useEffect(() => {
    //     const activity = document.getElementById("activityLine");
    //     const activityData = [
    //         {
    //             first: [50, 75, 34, 55, 25, 70, 30, 80, 30, 90, 25, 65],
    //         },
    //         {
    //             first: [50, 35, 10, 45, 40, 50, 60, 35, 10, 70, 34, 35],
    //         },
    //         {
    //             first: [20, 35, 70, 45, 40, 35, 30, 35, 10, 40, 60, 20],
    //         },
    //     ];

    //     if (activity !== null) {
    //         activity.height = 350;

    //         const config = {
    //             type: "line",
    //             data: {
    //                 labels: [
    //                     "Jan",
    //                     "Feb",
    //                     "Mar",
    //                     "Apr",
    //                     "May",
    //                     "Jun",
    //                     "Jul",
    //                     "Aug",
    //                     "Sep",
    //                     "Oct",
    //                     "Nov",
    //                     "Dec",
    //                 ],
    //                 datasets: [
    //                     {
    //                         // label: "My First dataset",
    //                         data: [50, 75, 34, 55, 25, 70, 50, 80, 60, 90, 45, 65],
    //                         borderColor: "#EA7A9A",
    //                         borderWidth: "4",
    //                         barThickness: "flex",
    //                         backgroundColor: "rgba(255, 199, 182, 0.3)",
    //                         minBarLength: 10,
    //                     },
    //                 ],
    //             },
    //             options: {
    //                 responsive: true,
    //                 maintainAspectRatio: false,
    //                 legend: {
    //                     display: false,
    //                 },
    //                 scales: {
    //                     y: {
    //                         grid: {
    //                             color: "rgba(0,0,0,0.1)",
    //                             drawBorder: true,
    //                         },
    //                         ticks: {
    //                             fontColor: "#3e4954",
    //                             max: 100,
    //                             min: 0,
    //                             stepSize: 20,
    //                         },
    //                     },
    //                     x: {
    //                         barPercentage: 0.3,
    //                         grid: {
    //                             display: false,
    //                             zeroLineColor: "transparent",
    //                         },
    //                         ticks: {
    //                             stepSize: 20,
    //                             fontColor: "#3e4954",
    //                             fontFamily: "Nunito, sans-serif",
    //                         },
    //                     },
    //                 },
    //                 elements: {
    //                     point: {
    //                         radius: 0,
    //                         borderWidth: 0,
    //                     },
    //                 },
    //                 tooltips: {
    //                     mode: "index",
    //                     intersect: false,
    //                     titleFontColor: "#888",
    //                     bodyFontColor: "#555",
    //                     titleFontSize: 12,
    //                     bodyFontSize: 15,
    //                     backgroundColor: "rgba(255,255,255,1)",
    //                     displayColors: true,
    //                     xPadding: 10,
    //                     yPadding: 7,
    //                     borderColor: "rgba(220, 220, 220, 1)",
    //                     borderWidth: 1,
    //                     caretSize: 6,
    //                     caretPadding: 10,
    //                 },
    //             },
    //         };

    //         if (chartRef.current) {
    //             chartRef.current.destroy();
    //         }

    //         const ctx = activity.getContext("2d");
    //         chartRef.current = new Chart(ctx, config);

    //         const items = document.querySelectorAll("#user-activity .nav-tabs .nav-item");
    //         items.forEach((item, index) => {
    //             item.addEventListener("click", () => {
    //                 config.data.datasets[0].data = activityData[index].first;
    //                 chartRef.current.update();
    //             });
    //         });
    //     }
    // }, []);
    const today = moment();
    const yyyy = today.year();
    const mm = String(today.month() + 1).padStart(2, '0'); // Months are zero-indexed
    const dd = String(today.date()).padStart(2, '0');

    const formattedCurrentDate = `${yyyy}-${mm}-${dd}`;

    const [dates, setDates] = useState({
        start_date: '',
        end_date: ''
    });
    const [cardsValues, setCardsValues] = useState({
        items: 0,
        revenue: 0,
        orders: 0,
        customers: 0,
        sucOrders: 0,
        unsucOrders: 0
    });
    const [trendItems, setTrendItems] = useState({ list: [], status: 'today' });
    const [series, setSeries] = useState(0);
    const [series2, setSeries2] = useState([0, 0, 0]);
    const [orders, setOrders] = useState({ list: [], status: 'today' });
    const [average, setAverage] = useState({
        order: 'weekly',
        items: 'weekly',
        amounts: 'weekly'
    });
    const [summary, setSummary] = useState({
        delivery: 0,
        pickuped: 0,
        cancelled: 0,
        total: 0,
        limit: 500000,
        status: 'monthly'
    });

    var options = {
        chart: {
            height: 300,
            type: 'radialBar',
            offsetY: -10
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                dataLabels: {
                    name: {
                        fontSize: '16px',
                        color: undefined,
                        offsetY: 120
                    },
                    value: {
                        offsetY: 0,
                        fontSize: '34px',
                        color: 'black',
                        formatter: function (val) {
                            return Number(val).toFixed(2) + "%";
                        }
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            colors: '#08C873',
            gradient: {
                shade: 'dark',
                shadeIntensity: 0.15,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 50, 65, 91]
            },
        },
        stroke: {
            colors: '#08C873'
        },
        labels: [''],
    };

    const options2 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                grid: {
                    color: "rgba(0,0,0,0.1)",
                    drawBorder: true,
                },
                ticks: {
                    fontColor: "#3e4954",
                    max: 100,
                    min: 0,
                    stepSize: 20,
                },
            },
            x: {
                barPercentage: 0.3,
                grid: {
                    display: false,
                    zeroLineColor: "transparent",
                },
                ticks: {
                    stepSize: 20,
                    fontColor: "#3e4954",
                    fontFamily: "Nunito, sans-serif",
                },
            },
        },
        elements: {
            point: {
                radius: 0,
                borderWidth: 0,
            },
            line: {
                tension: 0.4  // smooth lines
            },
        },
        hover: { mode: 'index', intersect: false },
        tooltips: {
            mode: "index",
            intersect: false,
            titleFontColor: "#888",
            bodyFontColor: "#555",
            titleFontSize: 12,
            bodyFontSize: 15,
            backgroundColor: "rgba(255,255,255,1)",
            displayColors: true,
            xPadding: 10,
            yPadding: 7,
            borderColor: "rgba(220, 220, 220, 1)",
            borderWidth: 1,
            caretSize: 6,
            caretPadding: 10,
        },
    }

    // var options3 = {
    //     chart: {
    //         height: 80,
    //         width: 80,
    //         type: 'radialBar',
    //     },
    //     labels: ['Progress'],
    // };
    var options3 = {
        chart: {
            height: 80,
            type: 'radialBar',
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: '50%',
                }
            },
        },
        // labels: [''],
    };

    var options4 = {
        plugins: {
            legend: {
                display: false,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                display: false,
                ticks: {
                    beginAtZero: true,
                    display: false,
                    max: 100,
                    min: 0,
                    stepSize: 10
                },
                gridLines: {
                    display: false,
                    drawBorder: false
                }
            },
            x: {
                display: false,
                barPercentage: 0.4,
                gridLines: {
                    display: false,
                    drawBorder: false
                },
                ticks: {
                    display: false
                }
            }
        }
    }


    var options5 = {
        chart: {
            type: 'donut',
        },
        colors: ['#08C873', '#FF9F00', '#FF4560'],
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        labels: ['Delivery Orders', 'Pickup Orders', 'Cancelled Orders']
    }

    const [data, setData] = useState({
        labels: [""],
        datasets: [
            {
                data: [0],
                borderColor: "#08C873",
                borderWidth: "4",
                barThickness: "flex",
                backgroundColor: "#08C873",
                minBarLength: 10,
            },
        ],
    });
    const [data2, setData2] = useState({
        defaultFontFamily: 'Poppins',
        labels: [""],
        datasets: [
            {
                data: [0],
                borderColor: '#08C873',
                backgroundColor: '#08C873',
                hoverBackgroundColor: '#08C873',
                borderWidth: "4",
                barThickness: "flex",
                minBarLength: 2,
            }
        ]
    });

    const [data3, setData3] = useState({
        defaultFontFamily: 'Poppins',
        labels: [""],
        datasets: [
            {
                data: [0],
                data2: 0,
                borderColor: '#08C873',
                backgroundColor: '#08C873',
                hoverBackgroundColor: '#08C873',
                borderWidth: "4",
                barThickness: "flex",
                minBarLength: 2,
            }
        ]
    });

    const [data4, setData4] = useState({
        defaultFontFamily: 'Poppins',
        labels: [""],
        datasets: [
            {
                data: [0],
                data2: 0,
                borderColor: '#08C873',
                backgroundColor: '#08C873',
                hoverBackgroundColor: '#08C873',
                borderWidth: "4",
                barThickness: "flex",
                minBarLength: 2,
            }
        ]
    });

    useEffect(() => {
        getProfileSnapshot().then(doc => {
            setResto(doc.data() || {});
            setTimezone(normalizeTimezone(doc.data()?.restaurant_timezone));
        }).catch(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (!timezone) return;
        return watchRestaurantDay({
            timezone,
            refreshOnStart: true,
            onDayChange: () => refreshLatest.current(),
        });
    }, [timezone]);

    const [resto, setResto] = useState({});

    const getProfile = () => {
        return getProfileSnapshot().then(doc => {
            setResto(doc.data());
            setTimezone(normalizeTimezone(doc.data()?.restaurant_timezone));
            // setLoading(false);
        })
    }

    const handleDates = async (start, end, isCustom = true) => {
        console.log('start', start, 'end', end);
        if (timezone && start && end && start <= end) {
            customDateRange.current = isCustom;
            const { start: startTimestamp, end: endTimestamp } = calendarRange(start, end, timezone);
            setDates({ start_date: start, end_date: end });
            let query = { get: () => getOrdersSnapshot() };
            return query.get().then(querySnapshot => {
                let arr = [];
                querySnapshot.docs.map((doc) => {
                    if (orderMillis(doc.data()) >= startTimestamp && orderMillis(doc.data()) < endTimestamp) {
                        arr.push(doc.data());
                    }
                })
                setSummary({
                    ...summary,
                    delivery: arr.filter(el => el.order_status === 5).length,
                    pickuped: arr.filter(el => el.order_status === 4).length,
                    cancelled: arr.filter(el => el.order_status === 2).length,
                });
                setSeries2([
                    arr.filter(el => el.order_status === 5).length,
                    arr.filter(el => el.order_status === 4).length,
                    arr.filter(el => el.order_status === 2).length
                ])
            });
        }

        return Promise.resolve();
    }

    const getOrders = async (types, type, type2) => {
        setLoading(true);
        let ord = [];
        let ord2 = [];
        let allItems = [];
        let allItems2 = [];
        let trends = [];
        await getOrdersSnapshot().then(async querySnapshot => {
                console.log(querySnapshot.docs.length);
                var daysAgo = {}
                for (var i = 1; i <= 7; i++) {
                    daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY")
                }
                var timestamp = moment(daysAgo[7].split(' ')[2], daysAgo[7].split(' ')[1] - 1, daysAgo[7].split(' ')[0]).valueOf();
                var daysAgo2 = {}
                for (var j = 1; j <= 30; j++) {
                    daysAgo2[j] = moment().subtract(j, 'days').format("DD MM YYYY")
                }
                var timestamp2 = moment(daysAgo2[30].split(' ')[2], daysAgo2[30].split(' ')[1] - 1, daysAgo2[30].split(' ')[0]).valueOf();
                querySnapshot.docs.map(doc => {
                    const order = { ...doc.data(), doc_id: doc.id };
                    if (type === 'today') {
                        if (moment(parseInt(orderMillis(doc.data()))).format("DD/MM/YYYY") === moment(Date.now()).format("DD/MM/YYYY")) {
                            ord.push(order);
                        }
                    } else if (type === 'weekly') {
                        if (orderMillis(doc.data()) <= Date.now() && orderMillis(doc.data()) >= timestamp) {
                            ord.push(order);
                        }
                    } else if (type === 'monthly') {
                        if (orderMillis(doc.data()) <= Date.now() && orderMillis(doc.data()) >= timestamp2) {
                            ord.push(order);
                        }
                    }
                    if (type2 === 'today') {
                        if (moment(parseInt(orderMillis(doc.data()))).format("DD/MM/YYYY") === moment(Date.now()).format("DD/MM/YYYY")) {
                            ord2.push(order);
                        }
                    } else if (type2 === 'weekly') {
                        if (orderMillis(doc.data()) <= Date.now() && orderMillis(doc.data()) >= timestamp) {
                            ord2.push(order);
                        }
                    } else if (type2 === 'monthly') {
                        if (orderMillis(doc.data()) <= Date.now() && orderMillis(doc.data()) >= timestamp2) {
                            ord2.push(order);
                        }
                    }
                });
                // });
                ord = await Promise.all(ord.map(order => getOrderWithItems(order)));
                ord2 = await Promise.all(ord2.map(order => getOrderWithItems(order)));
                allItems = ord2.flatMap(order => (order.items || []).map(item => ({ ...item, order_id: order.order_id })));
                await Promise.all(allItems.map(async el => {
                    if (hasItemWithKeyAndValue(trends, 'item_id', el.item_id)) {
                        // trends.push({ ...el, count: trends.filter(tr => tr.item_id === el.item_id)[0].count + 1 });
                        // trends = [...trends, { ...el, count: trends.filter(tr => tr.item_id === el.item_id)[0].count + 1 }];
                        trends.forEach((element, index) => {
                            if (element.item_id === el.item_id) {
                                trends[index]['count'] = element.count + 1;
                            }
                        });
                    } else {
                        trends.push({ ...el, count: 1 })
                    }
                }));
                console.log(trends)
                setTrendItems({ list: trends.sort((a, b) => b.count - a.count), status: type2 });
                // console.log('final order', ord);
                setOrders({ list: ord.sort((a, b) => b.order_id - a.order_id), status: type });
                if (types === 'initial') {
                    setLoading(false);
                }
            });
    }

    function hasItemWithKeyAndValue(arr, key, value) {
        return arr.some(item => item[key] === value);
    }

    const getOrderItemsForOrder = async (order) => {
        const primaryId = order?.doc_id || order?.order_id;
        const fallbackId = order?.order_id;
        const snapshot = await getOrderItemsSnapshot(primaryId);

        if (snapshot.docs.length > 0 || !fallbackId || fallbackId === primaryId) {
            return snapshot;
        }

        return getOrderItemsSnapshot(fallbackId);
    }

    const getOrderWithItems = async (order) => {
        const snapshot = await getOrderItemsForOrder(order);
        const items = snapshot.docs.map(doc => doc.data());

        return { ...order, items };
    }

    const getRevenue = async (type) => {
        setLoading(true);
        var monthName = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
        var d = moment();
        var datasets = [];
        var labels = [];
        d.date(1);
        for (let i = 0; i <= 11; i++) {
            datasets.push(monthName[d.month()] + ' ' + d.year());
            labels.push({ month: (monthName[d.month()]).slice(0, 3), value: 0, orders: 0 });
            d.month(d.month() - 1);
        }
        await getOrdersSnapshot().then(querySnapshot => {
            querySnapshot.docs.map(async (doc) => {
                let dt = moment(orderMillis(doc.data()));
                let month = (monthName[dt.month()]) + ' ' + dt.year();
                let index = datasets.indexOf(month);
                if (index !== -1) {
                    let total = labels[index].value + doc.data().items_total;
                    // labels = await Promise.all(labels.map(elem => {
                    //     console.log(elem.month, (monthName[dt.month() + 1]).slice(0, 3));
                    //     if (elem.month === (monthName[dt.month() + 1]).slice(0, 3))
                    //         return { ...elem, value: total, orders: elem.orders + 1 }
                    //     else return elem
                    // }))
                    labels.forEach((element, index) => {
                        if (element.month === (monthName[dt.month()]).slice(0, 3)) {
                            labels[index]['value'] = total;
                            labels[index]['orders'] = element.orders + 1
                        }
                    });
                    // labels = [...labels, { month: (monthName[dt.month() + 1]).slice(0, 3), value: total }];
                }
            });
        });
        if (type === 'initial') {
            setLoading(false);
        }
        setData({ ...data, labels: labels.map(el => { return el.month }).reverse(), datasets: [{ ...data.datasets[0], data: labels.map(el => { return el.value }).reverse() }] })
    }

    const getSummary = async (types, type) => {
        setSeries(0);
        setLoading(true);
        let query = { get: () => getOrdersSnapshot() };
        if (type === 'today') {
            return query.get().then(querySnapshot => {
                let total = 0;
                let arr = [];
                querySnapshot.docs.map((doc) => {
                    if (moment(orderMillis(doc.data())).isSame(moment(), 'day')) {
                        arr.push(doc.data());
                        total += doc.data().items_total;
                    }
                });
                setSummary({
                    delivery: arr.filter(el => el.order_status === 5).length,
                    pickuped: arr.filter(el => el.order_status === 4).length,
                    cancelled: arr.filter(el => el.order_status === 2).length,
                    total,
                    limit: 10000,
                    status: type
                });
                setSeries((total / 10000) * 100);
                if (types === 'initial') {
                    setLoading(false);
                }
            })
        } else if (type === 'weekly') {
            var daysAgo = {}
            for (var i = 1; i <= 7; i++) {
                daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY")
            }
            var timestamp = moment(daysAgo[7].split(' ')[2], daysAgo[7].split(' ')[1] - 1, daysAgo[7].split(' ')[0]).valueOf();
            return query.get().then(querySnapshot => {
                let total = 0;
                let arr = [];
                querySnapshot.docs.map((doc) => {
                    if (orderMillis(doc.data()) <= Date.now() && orderMillis(doc.data()) >= timestamp) {
                        arr.push(doc.data());
                        total += doc.data().items_total;
                    }
                })
                setSummary({
                    delivery: arr.filter(el => el.order_status === 5).length,
                    pickuped: arr.filter(el => el.order_status === 4).length,
                    cancelled: arr.filter(el => el.order_status === 2).length,
                    total,
                    limit: 100000,
                    status: type
                });
                setSeries((total / 100000) * 100);
                if (types === 'initial') {
                    setLoading(false);
                }
            })
        } else {
            var daysAgo2 = {}
            for (var i = 1; i <= 30; i++) {
                daysAgo2[i] = moment().subtract(i, 'days').format("DD MM YYYY")
            }
            var timestamp2 = moment(daysAgo2[30].split(' ')[2], daysAgo2[30].split(' ')[1] - 1, daysAgo2[30].split(' ')[0]).valueOf();
            return query.get().then(querySnapshot => {
                let total = 0;
                let arr = [];
                querySnapshot.docs.map((doc) => {
                    if (orderMillis(doc.data()) <= Date.now() && orderMillis(doc.data()) >= timestamp2) {
                        arr.push(doc.data());
                        total += doc.data().items_total;
                    }
                })
                console.log(arr);

                setSummary({
                    delivery: arr.filter(el => el.order_status === 5).length,
                    pickuped: arr.filter(el => el.order_status === 4).length,
                    cancelled: arr.filter(el => el.order_status === 2).length,
                    total,
                    limit: 500000,
                    status: type
                });
                setSeries((total / 500000) * 100);
                if (types === 'initial') {
                    setLoading(false);
                }
            })
        }
    };

    const getAverages = async (type, avg1, avg2, avg3, check) => {
        setLoading(true);
        let query = { get: () => getOrdersSnapshot() };
        if (check === 'check_all') {
            var orders = await query.get().then(querySnapshot => querySnapshot.docs.map((doc) => { return { id: doc.id, data: doc.data() } }));
        }
        setAverage({ order: avg1, items: avg2, amounts: avg3 })
        if (avg1 && (check === 'check_all' || check === 'check 1')) {
            if (avg1 === 'weekly') {
                let dayName = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
                let datasets = [];
                let labels1 = [];
                let daysAgo = {}
                for (let i = 1; i <= 7; i++) {
                    daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY");
                    labels1.push({ day: (dayName[moment(daysAgo[i].split(' ')[2], daysAgo[i].split(' ')[1] - 1, daysAgo[i].split(' ')[0]).day()]).slice(0, 3), orders: 0 })
                }
                let timestamp = moment(daysAgo[7].split(' ')[2], daysAgo[7].split(' ')[1] - 1, daysAgo[7].split(' ')[0]).valueOf();
                if (check !== 'check_all') {
                    await query.get().then(querySnapshot => {
                        querySnapshot.docs.map((doc) => {
                            if (orderMillis(doc.data()) <= Date.now() && orderMillis(doc.data()) >= timestamp) {
                                let dt = moment(orderMillis(doc.data()));
                                labels1.forEach((element, index) => {
                                    if (element.day === (dayName[dt.day()]).slice(0, 3)) {
                                        labels1[index]['orders'] = element.orders + 1
                                    }
                                });
                            }
                        })
                    });
                    setLoading(false);
                } else {
                    await Promise.all(orders.map(el => {
                        if (orderMillis(el) <= Date.now() && orderMillis(el) >= timestamp) {
                            let dt = moment(orderMillis(el));
                            labels1.forEach((element, index) => {
                                if (element.day === (dayName[dt.day()]).slice(0, 3)) {
                                    labels1[index]['orders'] = element.orders + 1
                                }
                            });
                        }
                    }))
                }
                setData2({ ...data2, labels: labels1.map(el => { return el.day }).reverse(), datasets: [{ ...data2.datasets[0], data: labels1.map(el => { return el.orders }).reverse() }] })
            }
            if (avg1 === 'monthly') {
                let monthName = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
                let d = moment();
                let datasets = [];
                let labels1 = [];
                d.date(1);
                for (let i = 0; i <= 11; i++) {
                    datasets.push(monthName[d.month()] + ' ' + d.year());
                    labels1.push({ month: (monthName[d.month()]).slice(0, 3), orders: 0 });
                    d.month(d.month() - 1);
                }
                if (check !== 'check_all') {
                    await query.get().then(querySnapshot => {
                        querySnapshot.docs.map(async (doc) => {
                            let dt = moment(orderMillis(doc.data()));
                            let month = (monthName[dt.month() + 1]) + ' ' + dt.year();
                            let index = datasets.indexOf(month);
                            if (index !== -1) {
                                labels1.forEach((element, index) => {
                                    if (element.month === (monthName[dt.month() + 1]).slice(0, 3)) {
                                        labels1[index]['orders'] = element.orders + 1
                                    }
                                });
                            }
                        });
                    });
                    setLoading(false);
                } else {
                    await Promise.all(orders.map(el => {
                        let dt = moment(orderMillis(el));
                        let month = (monthName[dt.month() + 1]) + '' + dt.year();
                        let index = datasets.indexOf(month);
                        if (index !== -1) {
                            labels1.forEach((element, index) => {
                                if (element.month === (monthName[dt.month() + 1]).slice(0, 3)) {
                                    labels1[index]['orders'] = element.orders + 1
                                }
                            });
                        }
                    }));
                }
                setData2({ ...data2, labels: labels1.map(el => { return el.month }).reverse(), datasets: [{ ...data2.datasets[0], data: labels1.map(el => { return el.orders }).reverse() }] })
            }
            if (avg1 === 'yearly') {
                let d = moment();
                let labels1 = [];
                for (let i = 0; i <= 9; i++) {
                    labels1.push({ year: d.year(), orders: 0 });
                    d.year(d.year() - 1);
                };
                if (check !== 'check_all') {
                    await query.get().then(querySnapshot => {
                        querySnapshot.docs.map(async (doc) => {
                            let dt = moment(orderMillis(doc.data()));
                            let yr = dt.year();
                            let index = labels1.map(el => { return el.year }).indexOf(yr);
                            if (index !== -1) {
                                labels1.forEach((element, index) => {
                                    if (element.year === yr) {
                                        labels1[index]['orders'] = element.orders + 1
                                    }
                                });
                            }
                        });
                    });
                    setLoading(false);
                } else {
                    await Promise.all(orders.map(el => {
                        let dt = moment(orderMillis(el));
                        let yr = dt.year();
                        let index = labels1.map(el => { return el.year }).indexOf(yr);
                        if (index !== -1) {
                            labels1.forEach((element, index) => {
                                if (element.year === yr) {
                                    labels1[index]['orders'] = element.orders + 1
                                }
                            });
                        }
                    }));
                }
                setData2({ ...data2, labels: labels1.map(el => { return el.year }).reverse(), datasets: [{ ...data2.datasets[0], data: labels1.map(el => { return el.orders }).reverse() }] })
            }
        }
        if (avg2 && (check === 'check_all' || check === 'check 2')) {
            if (avg2 === 'weekly') {
                let dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                let labels2 = [];
                let daysAgo = {};
                let orderVal = 0;
                for (let i = 1; i <= 7; i++) {
                    daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY");
                    labels2.push({ day: (dayName[moment(daysAgo[i].split(' ')[2], daysAgo[i].split(' ')[1] - 1, daysAgo[i].split(' ')[0]).day()]).slice(0, 3), items: 0 })
                }
                let timestamp = moment(daysAgo[7].split(' ')[2], daysAgo[7].split(' ')[1] - 1, daysAgo[7].split(' ')[0]).valueOf();
                if (check !== 'check_all') {
                    await query.get().then(async querySnapshot => {
                        const promises = querySnapshot.docs.map((doc) => { return { id: doc.id, data: doc.data() } });
                        await Promise.all(promises.map(async (doc) => {
                            let itm = await getOrderItemsSnapshot(doc.id).then((snapshot) => { return snapshot.docs.length });
                            if (doc.id <= Date.now() && doc.id >= timestamp) {
                                let dt = moment(parseInt(doc.id));
                                orderVal += 1;
                                labels2.forEach(async (element, index) => {
                                    if (element.day === (dayName[dt.day()]).slice(0, 3)) {
                                        labels2[index]['items'] = element.items + itm;
                                    }
                                });
                            }
                        }));
                        setLoading(false);
                    });
                } else {
                    await Promise.all(orders.map(async (doc) => {
                        let itm = await getOrderItemsSnapshot(doc.id).then((snapshot) => { return snapshot.docs.length });
                        if (doc.id <= Date.now() && doc.id >= timestamp) {
                            orderVal += 1;
                            let dt = moment(parseInt(doc.id));
                            labels2.forEach(async (element, index) => {
                                if (element.day === (dayName[dt.day()]).slice(0, 3)) {
                                    labels2[index]['items'] = element.items + itm;
                                }
                            });
                        }
                    }));
                }
                setData3({ ...data3, labels: labels2.map(el => { return el.day }).reverse(), datasets: [{ ...data3.datasets[0], data: labels2.map(el => { return el.items }).reverse(), data2: orderVal }] })
            }
            if (avg2 === 'monthly') {
                var monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var d = moment();
                var datasets = [];
                var labels2 = [];
                let orderVal = 0;
                d.date(1);
                for (let i = 0; i <= 11; i++) {
                    datasets.push(monthName[d.month()] + ' ' + d.year());
                    labels2.push({ month: (monthName[d.month()]).slice(0, 3), items: 0 });
                    d.month(d.month() - 1);
                }
                if (check !== 'check_all') {
                    await query.get().then(async querySnapshot => {
                        const promises = querySnapshot.docs.map((doc) => { return { id: doc.id, data: doc.data() } });
                        await Promise.all(promises.map(async (doc) => {
                            let itm = await getOrderItemsSnapshot(doc.id).then((snapshot) => { return snapshot.docs.length })
                            let dt = moment(parseInt(doc.id));
                            let month = (monthName[dt.month() + 1]) + ' ' + dt.year();
                            let index = datasets.indexOf(month);
                            if (index !== -1) {
                                orderVal += 1;
                                labels2.forEach(async (element, index) => {
                                    if (element.month === (monthName[dt.month() + 1]).slice(0, 3)) {
                                        labels2[index]['items'] = element.items + itm;
                                    }
                                });
                            }
                        }));
                    });
                    setLoading(false);
                } else {
                    await Promise.all(orders.map(async (doc) => {
                        let itm = await getOrderItemsSnapshot(doc.id).then((snapshot) => { return snapshot.docs.length })
                        let dt = moment(parseInt(doc.id));
                        let month = (monthName[dt.month() + 1]) + ' ' + dt.year();
                        let index = datasets.indexOf(month);
                        if (index !== -1) {
                            orderVal += 1;
                            labels2.forEach(async (element, index) => {
                                if (element.month === (monthName[dt.month() + 1]).slice(0, 3)) {
                                    labels2[index]['items'] = element.items + itm;
                                }
                            });
                        }
                    }));
                }
                setData3({ ...data3, labels: labels2.map(el => { return el.month }).reverse(), datasets: [{ ...data3.datasets[0], data: labels2.map(el => { return el.items }).reverse(), data2: orderVal }] })
            }
            if (avg2 === 'yearly') {
                let datasets = [];
                let d = moment();
                let labels2 = [];
                let orderVal = 0;
                for (let i = 0; i <= 9; i++) {
                    datasets.push(d.year());
                    labels2.push({ year: d.year(), items: 0 });
                    d.year(d.year() - 1);
                };
                if (check !== 'check_all') {
                    await query.get().then(async querySnapshot => {
                        const promises = querySnapshot.docs.map((doc) => { return { id: doc.id, data: doc.data() } });
                        await Promise.all(promises.map(async (doc) => {
                            let itm = await getOrderItemsSnapshot(doc.id).then((snapshot) => { return snapshot.docs.length })
                            let dt = moment(parseInt(doc.id));
                            let yr = dt.year();
                            let index = datasets.indexOf(parseInt(yr));
                            if (index !== -1) {
                                orderVal += 1;
                                labels2.forEach(async (element, index) => {
                                    if (element.year === yr) {
                                        labels2[index]['items'] = element.items + itm;
                                    }
                                });
                            }
                        }));
                    });
                    setLoading(false);
                } else {
                    await Promise.all(orders.map(async (doc) => {
                        let itm = await getOrderItemsSnapshot(doc.id).then((snapshot) => { return snapshot.docs.length })
                        let dt = moment(parseInt(doc.id));
                        let yr = dt.year();
                        let index = datasets.indexOf(parseInt(yr));
                        if (index !== -1) {
                            orderVal += 1;
                            labels2.forEach(async (element, index) => {
                                if (element.year === yr) {
                                    labels2[index]['items'] = element.items + itm;
                                }
                            });
                        }
                    }));
                }
                setData3({ ...data3, labels: labels2.map(el => { return el.year }).reverse(), datasets: [{ ...data3.datasets[0], data: labels2.map(el => { return el.items }).reverse(), data2: orderVal }] })
            }
        }
        if (avg3 && (check === 'check_all' || check === 'check 3')) {
            if (avg3 === 'weekly') {
                let dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                let labels3 = [];
                let daysAgo = {};
                let orderVal = 0;
                for (let i = 1; i <= 7; i++) {
                    daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY");
                    labels3.push({ day: (dayName[moment(daysAgo[i].split(' ')[2], daysAgo[i].split(' ')[1] - 1, daysAgo[i].split(' ')[0]).day()]).slice(0, 3), amount: 0 })
                }
                let timestamp = moment(daysAgo[7].split(' ')[2], daysAgo[7].split(' ')[1] - 1, daysAgo[7].split(' ')[0]).valueOf();
                if (check !== 'check_all') {
                    await query.get().then(querySnapshot => {
                        querySnapshot.docs.forEach((doc) => {
                            if (doc.id <= Date.now() && doc.id >= timestamp) {
                                let dt = moment(orderMillis(doc.data()));
                                orderVal += 1;
                                labels3.forEach((element, index) => {
                                    if (element.day === (dayName[dt.day()]).slice(0, 3)) {
                                        labels3[index]['amount'] = element.amount + doc.data().items_total
                                    }
                                });
                            }
                        })
                    });
                    if (type === 'initial') {
                        setLoading(false);
                    }
                } else {
                    await Promise.all(orders.map(el => {
                        if (el.id <= Date.now() && el.id >= timestamp) {
                            orderVal += 1;
                            let dt = moment(parseInt(el.data.order_id));
                            labels3.forEach((element, index) => {
                                if (element.day === (dayName[dt.day()]).slice(0, 3)) {
                                    labels3[index]['amount'] = element.amount + el.data.items_total
                                }
                            });
                        }
                    }));
                    setLoading(false);
                }
                setData4({ ...data4, labels: labels3.map(el => { return el.day }).reverse(), datasets: [{ ...data4.datasets[0], data: labels3.map(el => { return el.amount }).reverse(), data2: orderVal }] })
            }
            if (avg3 === 'monthly') {
                let monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                let d = moment();
                let datasets = [];
                let labels3 = [];
                let orderVal = 0;
                d.date(1);
                for (let i = 0; i <= 11; i++) {
                    datasets.push(monthName[d.month()] + ' ' + d.year());
                    labels3.push({ month: (monthName[d.month()]).slice(0, 3), amount: 0 });
                    d.month(d.month() - 1);
                }
                if (check !== 'check_all') {
                    await query.get().then(querySnapshot => {
                        querySnapshot.docs.map(async (doc) => {
                            let dt = moment(orderMillis(doc.data()));
                            let month = (monthName[dt.month() + 1]) + ' ' + dt.year();
                            let index = datasets.indexOf(month);
                            if (index !== -1) {
                                orderVal += 1;
                                labels3.forEach((element, index) => {
                                    if (element.month === (monthName[dt.month() + 1]).slice(0, 3)) {
                                        labels3[index]['amount'] = element.amount + doc.data().items_total
                                    }
                                });
                            }
                        });
                    });
                    if (type === 'initial') {
                        setLoading(false);
                    }
                } else {
                    await Promise.all(orders.map(async (doc) => {
                        let dt = moment(parseInt(doc.data.order_id));
                        let month = (monthName[dt.month() + 1]) + '' + dt.year();
                        let index = datasets.indexOf(month);
                        if (index !== -1) {
                            orderVal += 1;
                            labels3.forEach((element, index) => {
                                if (element.month === (monthName[dt.month() + 1]).slice(0, 3)) {
                                    labels3[index]['amount'] = element.amount + doc.data.items_total
                                }
                            });
                        }
                    }));
                    setLoading(false);
                }
                setData4({ ...data4, labels: labels3.map(el => { return el.month }).reverse(), datasets: [{ ...data4.datasets[0], data: labels3.map(el => { return el.amount }).reverse(), data2: orderVal }] })
            }
            if (avg3 === 'yearly') {
                let d = moment();
                let labels3 = [];
                let orderVal = 0;
                for (let i = 0; i <= 9; i++) {
                    labels3.push({ year: d.year(), amount: 0 });
                    d.year(d.year() - 1);
                };
                if (check !== 'check_all') {
                    await query.get().then(querySnapshot => {
                        querySnapshot.docs.map(async (doc) => {
                            let dt = moment(orderMillis(doc.data()));
                            let yr = dt.year();
                            let index = labels3.map(el => { return el.year }).indexOf(yr);
                            if (index !== -1) {
                                orderVal += 1;
                                labels3.forEach((element, index) => {
                                    if (element.year === yr) {
                                        labels3[index]['amount'] = element.amount + doc.data().items_total
                                    }
                                });
                            }
                        });
                    });
                    if (type === 'initial') {
                        setLoading(false);
                    }
                } else {
                    await Promise.all(orders.forEach(el => {
                        let dt = moment(parseInt(el.data.order_id));
                        let yr = dt.year();
                        let index = labels3.map(el => { return el.year }).indexOf(yr);
                        if (index !== -1) {
                            orderVal += 1;
                            labels3.forEach((element, index) => {
                                if (element.year === yr) {
                                    labels3[index]['amount'] = element.amount + el.data.items_total
                                }
                            });
                        }
                    }))
                    setLoading(false);
                }
                setData4({ ...data4, labels: labels3.map(el => { return el.year }).reverse(), datasets: [{ ...data4.datasets[0], data: labels3.map(el => { return el.amount }).reverse(), data2: orderVal }] })
            }
        }
    }

    const getAverages2 = async (sections, forceRefresh = false) => {
        try {
            const sectionKeys = sections.map(s => s.key);

            setLoadingMap(prev => ({
                ...prev,
                ...Object.fromEntries(
                    sectionKeys.map(key => [
                        key === 'orders'
                            ? 'avgOrders'
                            : key === 'items'
                                ? 'avgItems'
                                : 'avgAmounts',
                        true
                    ])
                )
            }));

            // fetch orders once
            const snapshot = await getOrdersSnapshot(forceRefresh);

            const allOrders = snapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            }));

            // update selected periods
            setAverage(prev => {
                const updated = { ...prev };

                sections.forEach(({ key, period }) => {
                    if (key === 'orders') updated.order = period;
                    if (key === 'items') updated.items = period;
                    if (key === 'amounts') updated.amounts = period;
                });

                return updated;
            });

            // process requested charts in parallel
            await Promise.all(
                sections.map(async ({ key, period }) => {
                    switch (key) {
                        case 'orders':
                            await computeOrdersChart(allOrders, period);
                            break;

                        case 'items':
                            await computeItemsChart(allOrders, period);
                            break;

                        case 'amounts':
                            await computeAmountsChart(allOrders, period);
                            break;

                        default:
                            break;
                    }
                })
            );
        } catch (err) {
            console.error('getAverages2 error', err);
        } finally {
            setLoadingMap(prev => ({
                ...prev,
                ...Object.fromEntries(
                    sections.map(({ key }) => [
                        key === 'orders'
                            ? 'avgOrders'
                            : key === 'items'
                                ? 'avgItems'
                                : 'avgAmounts',
                        false
                    ])
                )
            }));
        }
    };

    const computeOrdersChart = async (allOrders, period) => {
        if (period === 'weekly') {
            const dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            const labels = [];
            const daysAgo = {};

            for (let i = 1; i <= 7; i++) {
                daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY");
                labels.push({
                    day: dayName[
                        moment(
                            daysAgo[i].split(' ')[2],
                            daysAgo[i].split(' ')[1] - 1,
                            daysAgo[i].split(' ')[0]
                        ).day()
                    ].slice(0, 3),
                    orders: 0
                });
            }

            const timestamp = moment(
                daysAgo[7].split(' ')[2],
                daysAgo[7].split(' ')[1] - 1,
                daysAgo[7].split(' ')[0]
            ).valueOf();

            allOrders.forEach(order => {
                const orderDate = orderMillis(order.data);
                if (orderDate < moment().startOf('day').valueOf() && orderDate >= timestamp) {
                    const dt = moment(orderDate);

                    labels.forEach((item, idx) => {
                        if (item.day === dayName[dt.day()].slice(0, 3)) {
                            labels[idx].orders += 1;
                        }
                    });
                }
            });

            setData2(prev => ({
                ...prev,
                labels: labels.map(x => x.day).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.orders).reverse()
                }]
            }));
        }

        if (period === 'monthly') {
            const monthName = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];

            const d = moment();
            const datasets = [];
            const labels = [];

            d.date(1);

            for (let i = 0; i <= 11; i++) {
                datasets.push(`${monthName[d.month()]} ${d.year()}`);
                labels.push({
                    month: monthName[d.month()].slice(0, 3),
                    orders: 0
                });
                d.month(d.month() - 1);
            }

            allOrders.forEach(order => {
                const dt = moment(orderMillis(order.data));

                const month = `${monthName[dt.month()]} ${dt.year()}`;

                if (datasets.includes(month)) {
                    labels.forEach((item, idx) => {
                        if (item.month === monthName[dt.month()].slice(0, 3)) {
                            labels[idx].orders += 1;
                        }
                    });
                }
            });

            setData2(prev => ({
                ...prev,
                labels: labels.map(x => x.month).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.orders).reverse()
                }]
            }));
        }

        if (period === 'yearly') {
            const d = moment();
            const labels = [];

            for (let i = 0; i <= 9; i++) {
                labels.push({
                    year: d.year(),
                    orders: 0
                });
                d.year(d.year() - 1);
            }

            allOrders.forEach(order => {
                const yr = moment(orderMillis(order.data)).year();

                labels.forEach((item, idx) => {
                    if (item.year === yr) {
                        labels[idx].orders += 1;
                    }
                });
            });

            setData2(prev => ({
                ...prev,
                labels: labels.map(x => x.year).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.orders).reverse()
                }]
            }));
        }
    };

    const computeItemsChart = async (allOrders, period) => {
        const dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const monthName = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        let orderVal = 0;

        if (period === 'weekly') {
            const labels = [];
            const daysAgo = {};

            for (let i = 1; i <= 7; i++) {
                daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY");

                labels.push({
                    day: dayName[
                        moment(
                            daysAgo[i].split(' ')[2],
                            daysAgo[i].split(' ')[1] - 1,
                            daysAgo[i].split(' ')[0]
                        ).day()
                    ].slice(0, 3),
                    items: 0
                });
            }

            const timestamp = moment(
                daysAgo[7].split(' ')[2],
                daysAgo[7].split(' ')[1] - 1,
                daysAgo[7].split(' ')[0]
            ).valueOf();

            await Promise.all(
                allOrders.map(async order => {
                    const itemCount = await getOrderItemsSnapshot(order.id)
                        .then(snapshot => snapshot.docs.length);

                    if (orderMillis(order.data) < moment().startOf('day').valueOf() && orderMillis(order.data) >= timestamp) {
                        orderVal++;

                        const dt = moment(orderMillis(order.data));

                        labels.forEach((item, idx) => {
                            if (item.day === dayName[dt.day()].slice(0, 3)) {
                                labels[idx].items += itemCount;
                            }
                        });
                    }
                })
            );

            setData3(prev => ({
                ...prev,
                labels: labels.map(x => x.day).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.items).reverse(),
                    data2: orderVal
                }]
            }));
        }

        if (period === 'monthly') {
            const d = moment();
            const datasets = [];
            const labels = [];

            d.date(1);

            for (let i = 0; i <= 11; i++) {
                datasets.push(`${monthName[d.month()]} ${d.year()}`);
                labels.push({
                    month: monthName[d.month()].slice(0, 3),
                    items: 0
                });
                d.month(d.month() - 1);
            }

            await Promise.all(
                allOrders.map(async order => {
                    const itemCount = await getOrderItemsSnapshot(order.id)
                        .then(snapshot => snapshot.docs.length);

                    const dt = moment(orderMillis(order.data));
                    const month = `${monthName[dt.month()]} ${dt.year()}`;

                    if (datasets.includes(month)) {
                        orderVal++;

                        labels.forEach((item, idx) => {
                            if (item.month === monthName[dt.month()].slice(0, 3)) {
                                labels[idx].items += itemCount;
                            }
                        });
                    }
                })
            );

            setData3(prev => ({
                ...prev,
                labels: labels.map(x => x.month).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.items).reverse(),
                    data2: orderVal
                }]
            }));
        }

        if (period === 'yearly') {
            const d = moment();
            const years = [];
            const labels = [];

            for (let i = 0; i <= 9; i++) {
                years.push(d.year());

                labels.push({
                    year: d.year(),
                    items: 0
                });

                d.year(d.year() - 1);
            }

            await Promise.all(
                allOrders.map(async order => {
                    const itemCount = await getOrderItemsSnapshot(order.id)
                        .then(snapshot => snapshot.docs.length);

                    const yr = moment(orderMillis(order.data)).year();

                    if (years.includes(yr)) {
                        orderVal++;

                        labels.forEach((item, idx) => {
                            if (item.year === yr) {
                                labels[idx].items += itemCount;
                            }
                        });
                    }
                })
            );

            setData3(prev => ({
                ...prev,
                labels: labels.map(x => x.year).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.items).reverse(),
                    data2: orderVal
                }]
            }));
        }
    };

    const computeAmountsChart = async (allOrders, period) => {
        const dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const monthName = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        let orderVal = 0;

        if (period === 'weekly') {
            const labels = [];
            const daysAgo = {};

            for (let i = 1; i <= 7; i++) {
                daysAgo[i] = moment().subtract(i, 'days').format("DD MM YYYY");

                labels.push({
                    day: dayName[
                        moment(
                            daysAgo[i].split(' ')[2],
                            daysAgo[i].split(' ')[1] - 1,
                            daysAgo[i].split(' ')[0]
                        ).day()
                    ].slice(0, 3),
                    amount: 0
                });
            }

            const timestamp = moment(
                daysAgo[7].split(' ')[2],
                daysAgo[7].split(' ')[1] - 1,
                daysAgo[7].split(' ')[0]
            ).valueOf();

            allOrders.forEach(order => {
                if (orderMillis(order.data) < moment().startOf('day').valueOf() && orderMillis(order.data) >= timestamp) {
                    orderVal++;

                    const dt = moment(orderMillis(order.data));

                    labels.forEach((item, idx) => {
                        if (item.day === dayName[dt.day()].slice(0, 3)) {
                            labels[idx].amount += order.data.items_total;
                        }
                    });
                }
            });

            setData4(prev => ({
                ...prev,
                labels: labels.map(x => x.day).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.amount).reverse(),
                    data2: orderVal
                }]
            }));
        }

        if (period === 'monthly') {
            const d = moment();
            const datasets = [];
            const labels = [];

            d.date(1);

            for (let i = 0; i <= 11; i++) {
                datasets.push(`${monthName[d.month()]} ${d.year()}`);
                labels.push({
                    month: monthName[d.month()].slice(0, 3),
                    amount: 0
                });
                d.month(d.month() - 1);
            }

            allOrders.forEach(order => {
                const dt = moment(orderMillis(order.data));

                const month = `${monthName[dt.month()]} ${dt.year()}`;

                if (datasets.includes(month)) {
                    orderVal++;

                    labels.forEach((item, idx) => {
                        if (item.month === monthName[dt.month()].slice(0, 3)) {
                            labels[idx].amount += order.data.items_total;
                        }
                    });
                }
            });

            setData4(prev => ({
                ...prev,
                labels: labels.map(x => x.month).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.amount).reverse(),
                    data2: orderVal
                }]
            }));
        }

        if (period === 'yearly') {
            const d = moment();
            const labels = [];

            for (let i = 0; i <= 9; i++) {
                labels.push({
                    year: d.year(),
                    amount: 0
                });

                d.year(d.year() - 1);
            }

            allOrders.forEach(order => {
                const yr = moment(orderMillis(order.data)).year();

                labels.forEach((item, idx) => {
                    if (item.year === yr) {
                        labels[idx].amount += order.data.items_total;
                        orderVal++;
                    }
                });
            });

            setData4(prev => ({
                ...prev,
                labels: labels.map(x => x.year).reverse(),
                datasets: [{
                    ...prev.datasets[0],
                    data: labels.map(x => x.amount).reverse(),
                    data2: orderVal
                }]
            }));
        }
    };

    const getCardsValues = async (type) => {
        setLoading(true);
        var values = {
            item: 0,
            order: 0,
            revenue: 0,
            customer: 0,
            sucord: 0,
            unsucord: 0
        }
        await getItemsSnapshot().then(querySnapshot => {
                // console.log('item', querySnapshot.docs.length);
                values['item'] = querySnapshot.docs.length
            });
        await getOrdersSnapshot().then(querySnapshot => {
                // console.log('order', querySnapshot.docs.length);
                values['order'] = querySnapshot.docs.length;
                let users = [];
                let orders = { suc: 0, unsuc: 0 };
                querySnapshot.docs.map(elem => {
                    if (!users.includes(elem.data().user_id)) {
                        users.push(elem.data().user_id);
                    }
                    if (elem.data().order_status === 5) {
                        orders['suc'] = orders['suc'] + 1
                    }
                    if (elem.data().order_status === 2) {
                        orders['unsuc'] = orders['unsuc'] + 1
                    }
                });
                values['customer'] = users.length;
                values['sucord'] = orders.suc;
                values['unsucord'] = orders.unsuc;
            });
        await getOrdersSnapshot().then(querySnapshot => {
                let total = 0;
                querySnapshot.docs.map(elem => {
                    total += elem.data().items_total;
                });
                // console.log('revenue', total);
                values['revenue'] = total;
            });
        if (type === 'initial') {
            setLoading(false);
        }
        setCardsValues({ ...cardsValues, items: values.item, orders: values.order, revenue: values.revenue, customers: values.customer, unsucOrders: values.unsucord, sucOrders: values.sucord });
    };

    // useEffect(()=)
    const getAverageOrder = () => {
        if (data2.datasets[0].data.length > 1) {
            let vals = 0;
            let count = 0;
            data2.datasets[0].data.map(el => { vals += el; count = el > 0 ? count + 1 : count });
            // return parseInt(vals / (average.order === 'weekly' ? 7 : average.order === 'monthly' ? 12 : 10));
            return isNaN(parseInt(vals / count)) ? 0 : parseInt(vals / count);
        }
    }
    const getAverageOrder2 = () => {
        if (data3.datasets[0].data.length > 1) {
            // let vals = 0;
            // data3.datasets[0].data.map(el => vals += el);
            let count = 0;
            data3.datasets[0].data.map(el => { count = count + el });
            // data3.datasets[0].data.map(el => { vals += el; count = el > 0 ? count + 1 : count });
            // return parseInt(vals / (average.items === 'weekly' ? 7 : average.items === 'monthly' ? 12 : 10));
            return isNaN(parseInt(count / data3.datasets[0].data2)) ? 0 : parseInt(count / data3.datasets[0].data2);
            // return isNaN(parseInt(vals / count)) ? 0 : parseInt(vals / count);
        }
    }
    const getAverageOrder3 = () => {
        if (data4.datasets[0].data.length > 1) {
            // let vals = 0;
            // data4.datasets[0].data.map(el => vals += el);
            let count = 0;
            data4.datasets[0].data.map(el => { count = count + el });
            // data4.datasets[0].data.map(el => { vals += el; count = el > 0 ? count + 1 : count });
            // return parseInt(vals / (average.items === 'weekly' ? 7 : average.items === 'monthly' ? 12 : 10));
            return isNaN(parseInt(count / data4.datasets[0].data2)) ? 0 : parseInt(count / data4.datasets[0].data2);
            // return isNaN(parseInt(vals / count)) ? 0 : parseInt(vals / count);
        }
    }

    const refreshDashboard = async () => {
        if (refreshInFlight.current || !timezone) {
            return false;
        }

        refreshInFlight.current = true;
        setIsRefreshing(true);
        clearDashboardQueryCache();

        try {
            const results = await Promise.allSettled([
                getCardsValues('initial'),
                getSummary('initial', summary.status),
                getRevenue('initial'),
                getOrders('initial', orders.status, trendItems.status),
                // getAverages('initial', average.order, average.items, average.amounts, 'check_all'),
                getAverages2([
                    { key: 'orders', period: average.order },
                    { key: 'items', period: average.items },
                    { key: 'amounts', period: average.amounts }
                ], true),
                getProfile(),
                handleDates(
                    customDateRange.current ? dates.start_date
                        : moment(moment().year(), moment().month() - 1, moment().date()).format('YYYY-MM-DD'),
                    customDateRange.current ? dates.end_date : moment().format('YYYY-MM-DD'),
                    customDateRange.current
                )
            ]);
            const failed = results.find(result => result.status === 'rejected');
            if (failed) throw failed.reason;
            setLastUpdated(Date.now());
            return true;
        } finally {
            refreshInFlight.current = false;
            setIsRefreshing(false);
        }
    }

    useLayoutEffect(() => {
        refreshLatest.current = refreshDashboard;
    });

    return (
        <>
            <div className="customers-product-order" style={{ overflow: 'auto' }}>
                <div className="content-body">
                    <div className="container-fluid">
                        <div className="dashboard-toolbar">
                            <div>
                                <div className="dashboard-toolbar__eyebrow">Restaurant dashboard</div>
                                <h3 className="dashboard-toolbar__title">Dashboard overview</h3>
                            </div>
                            <div className="dashboard-toolbar__actions">
                                <span className="dashboard-toolbar__updated">Last updated {formatLastUpdated()}</span>
                                <button type="button" className="dashboard-refresh-button" onClick={refreshDashboard} disabled={isRefreshing}>
                                    {isRefreshing ? 'Refreshing...' : 'Refresh'}
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            {/* <div className="col-xl-3 col-xxl-6 col-sm-6">
                            <div className="card grd-card">
                                <div className="card-body">
                                    <div className="media align-items-center">
                                        <div className="media-body mr-2">
                                            <h2 className="text-white font-w600">{cardsValues.items}</h2>
                                            <span className="text-white">Total Items</span>
                                        </div>
                                        <div className='icon'>
                                            <svg width="40" height="40" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0)">
                                                    <path d="M30 7.03697H21.4497V1.75781H27.7137V0H19.6918V7.03697H11.1417V12.3132H12.9572L13.1193 14.7549H8.50227C5.03494 14.7549 2.17072 17.3859 1.80038 20.7561C0.75531 21.1073 0 22.0953 0 23.2571C0 24.4244 0.762405 25.4164 1.81526 25.7632C2.1769 28.1582 4.24873 30 6.74286 30H27.0115L28.1845 12.3132H30V7.03697ZM8.50227 16.5127H16.2202C18.669 16.5127 20.7097 18.2881 21.1263 20.6188H3.59619C4.01276 18.2881 6.05324 16.5127 8.50227 16.5127ZM2.63809 22.3766H22.0841C22.5696 22.3766 22.9646 22.7717 22.9646 23.2569C22.9646 23.7424 22.5696 24.1372 22.0841 24.1372H2.63809C2.15263 24.1372 1.75781 23.7424 1.75781 23.2569C1.75781 22.7717 2.15263 22.3766 2.63809 22.3766ZM6.74286 28.2422C5.26886 28.2422 4.02351 27.2479 3.63968 25.8952H21.0825C20.6989 27.2479 19.4536 28.2422 17.9794 28.2422H6.74286ZM25.3665 28.2422H21.7738C22.3618 27.5517 22.7655 26.7002 22.907 25.7632C23.9598 25.4164 24.7224 24.4244 24.7224 23.2571C24.7224 22.0953 23.9671 21.1073 22.9221 20.7561C22.5517 17.3859 19.6877 14.7549 16.2202 14.7549H14.881L14.7189 12.3132H26.4228L25.3665 28.2422ZM28.2422 10.5553H12.8996V8.79478H28.2422V10.5553Z" fill="#08C873" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="30" height="30" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                            <div className="col-xl-4 col-xxl-4 col-sm-6">
                                <div className="card grd-card">
                                    <div className="card-body">
                                        <div className="media align-items-center">
                                            <div className="media-body mr-2">
                                                {showInitialLoading ? (
                                                    <>
                                                        <div className="dashboard-skeleton dashboard-skeleton-line dashboard-skeleton-line--lg" style={{ width: '72%' }} />
                                                        <div className="dashboard-skeleton dashboard-skeleton-line" style={{ width: '44%', marginTop: '10px' }} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <h2 className="text-white font-w600">{resto?.currency_symbol ?? '$'} {Intl.NumberFormat('en-US').format(cardsValues?.revenue)}</h2>
                                                        <span className="text-white">Total Revenue</span>
                                                    </>
                                                )}
                                            </div>
                                            <div className='icon'>
                                                {/* <svg width="20" height="36" viewBox="0 0 20 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19.08 24.36C19.08 25.64 18.76 26.8667 18.12 28.04C17.48 29.1867 16.5333 30.1467 15.28 30.92C14.0533 31.6933 12.5733 32.1333 10.84 32.24V35.48H8.68V32.24C6.25333 32.0267 4.28 31.2533 2.76 29.92C1.24 28.56 0.466667 26.84 0.44 24.76H4.32C4.42667 25.88 4.84 26.8533 5.56 27.68C6.30667 28.5067 7.34667 29.0267 8.68 29.24V19.24C6.89333 18.7867 5.45333 18.32 4.36 17.84C3.26667 17.36 2.33333 16.6133 1.56 15.6C0.786667 14.5867 0.4 13.2267 0.4 11.52C0.4 9.36 1.14667 7.57333 2.64 6.16C4.16 4.74666 6.17333 3.96 8.68 3.8V0.479998H10.84V3.8C13.1067 3.98667 14.9333 4.72 16.32 6C17.7067 7.25333 18.5067 8.89333 18.72 10.92H14.84C14.7067 9.98667 14.2933 9.14667 13.6 8.4C12.9067 7.62667 11.9867 7.12 10.84 6.88V16.64C12.6 17.0933 14.0267 17.56 15.12 18.04C16.24 18.4933 17.1733 19.2267 17.92 20.24C18.6933 21.2533 19.08 22.6267 19.08 24.36ZM4.12 11.32C4.12 12.6267 4.50667 13.6267 5.28 14.32C6.05333 15.0133 7.18667 15.5867 8.68 16.04V6.8C7.29333 6.93333 6.18667 7.38667 5.36 8.16C4.53333 8.90667 4.12 9.96 4.12 11.32ZM10.84 29.28C12.28 29.12 13.4 28.6 14.2 27.72C15.0267 26.84 15.44 25.7867 15.44 24.56C15.44 23.2533 15.04 22.2533 14.24 21.56C13.44 20.84 12.3067 20.2667 10.84 19.84V29.28Z" fill="#08C873" />
                                                </svg> */}
                                                <p className='symbol'>{resto?.currency_symbol ?? '$'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-xxl-4 col-sm-6">
                                <div className="card grd-card">
                                    <div className="card-body">
                                        <div className="media align-items-center">
                                            <div className="media-body mr-2">
                                                {showInitialLoading ? (
                                                    <>
                                                        <div className="dashboard-skeleton dashboard-skeleton-line dashboard-skeleton-line--lg" style={{ width: '56%' }} />
                                                        <div className="dashboard-skeleton dashboard-skeleton-line" style={{ width: '38%', marginTop: '10px' }} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <h2 className="text-white font-w600">{cardsValues.orders}</h2>
                                                        <span className="text-white">Total Orders</span>
                                                    </>
                                                )}
                                            </div>
                                            <div className='icon'>
                                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10 32.5H28.75C29.7442 32.4989 30.6974 32.1035 31.4004 31.4004C32.1035 30.6974 32.4989 29.7442 32.5 28.75V18.75C32.5 18.4185 32.3683 18.1005 32.1339 17.8661C31.8995 17.6317 31.5815 17.5 31.25 17.5C30.9185 17.5 30.6005 17.6317 30.3661 17.8661C30.1317 18.1005 30 18.4185 30 18.75V28.75C29.9997 29.0814 29.8679 29.3992 29.6336 29.6336C29.3992 29.8679 29.0814 29.9997 28.75 30H10C9.66857 29.9997 9.3508 29.8679 9.11645 29.6336C8.88209 29.3992 8.7503 29.0814 8.75 28.75V11.25C8.7503 10.9186 8.88209 10.6008 9.11645 10.3664C9.3508 10.1321 9.66857 10.0003 10 10H21.25C21.5815 10 21.8995 9.8683 22.1339 9.63388C22.3683 9.39946 22.5 9.08152 22.5 8.75C22.5 8.41848 22.3683 8.10054 22.1339 7.86612C21.8995 7.6317 21.5815 7.5 21.25 7.5H10C9.00577 7.50109 8.05258 7.89653 7.34956 8.59956C6.64653 9.30258 6.25109 10.2558 6.25 11.25V28.75C6.25109 29.7442 6.64653 30.6974 7.34956 31.4004C8.05258 32.1035 9.00577 32.4989 10 32.5Z" fill="#08C873" />
                                                    <path d="M31.25 2.5C30.0138 2.5 28.8055 2.86656 27.7777 3.55331C26.7498 4.24007 25.9488 5.21619 25.4757 6.35823C25.0027 7.50027 24.8789 8.75693 25.1201 9.96931C25.3612 11.1817 25.9565 12.2953 26.8306 13.1694C27.7046 14.0435 28.8183 14.6388 30.0307 14.8799C31.243 15.1211 32.4997 14.9973 33.6417 14.5242C34.7838 14.0512 35.7599 13.2501 36.4466 12.2223C37.1334 11.1945 37.5 9.98613 37.5 8.75C37.498 7.093 36.8389 5.50442 35.6672 4.33274C34.4955 3.16106 32.907 2.50195 31.25 2.5ZM31.25 12.5C30.5083 12.5 29.7833 12.2801 29.1666 11.868C28.5499 11.456 28.0692 10.8703 27.7854 10.1851C27.5016 9.49984 27.4273 8.74584 27.572 8.01841C27.7167 7.29098 28.0739 6.6228 28.5983 6.09835C29.1228 5.5739 29.7909 5.21675 30.5184 5.07206C31.2458 4.92736 31.9998 5.00162 32.685 5.28545C33.3702 5.56928 33.9559 6.04993 34.368 6.66661C34.78 7.2833 35 8.00832 35 8.75C34.9989 9.74423 34.6034 10.6974 33.9004 11.4004C33.1974 12.1035 32.2442 12.4989 31.25 12.5Z" fill="#08C873" />
                                                    <path d="M12.5 15H18.75C19.0815 15 19.3995 14.8683 19.6339 14.6339C19.8683 14.3995 20 14.0815 20 13.75C20 13.4185 19.8683 13.1005 19.6339 12.8661C19.3995 12.6317 19.0815 12.5 18.75 12.5H12.5C12.1685 12.5 11.8505 12.6317 11.6161 12.8661C11.3817 13.1005 11.25 13.4185 11.25 13.75C11.25 14.0815 11.3817 14.3995 11.6161 14.6339C11.8505 14.8683 12.1685 15 12.5 15Z" fill="#08C873" />
                                                    <path d="M11.25 18.75C11.25 19.0815 11.3817 19.3995 11.6161 19.6339C11.8505 19.8683 12.1685 20 12.5 20H23.75C24.0815 20 24.3995 19.8683 24.6339 19.6339C24.8683 19.3995 25 19.0815 25 18.75C25 18.4185 24.8683 18.1005 24.6339 17.8661C24.3995 17.6317 24.0815 17.5 23.75 17.5H12.5C12.1685 17.5 11.8505 17.6317 11.6161 17.8661C11.3817 18.1005 11.25 18.4185 11.25 18.75Z" fill="#08C873" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-xxl-4 col-sm-6">
                                <div className="card grd-card">
                                    <div className="card-body">
                                        <div className="media align-items-center">
                                            <div className="media-body mr-2">
                                                {showInitialLoading ? (
                                                    <>
                                                        <div className="dashboard-skeleton dashboard-skeleton-line dashboard-skeleton-line--lg" style={{ width: '62%' }} />
                                                        <div className="dashboard-skeleton dashboard-skeleton-line" style={{ width: '42%', marginTop: '10px' }} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <h2 className="text-white font-w600">{cardsValues.customers}</h2>
                                                        <span className="text-white">Total Customers</span>
                                                    </>
                                                )}
                                            </div>
                                            <div className='icon'>
                                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16.2501 21.25C17.239 21.25 18.2057 20.9568 19.0279 20.4074C19.8502 19.8579 20.491 19.0771 20.8695 18.1634C21.2479 17.2498 21.3469 16.2445 21.154 15.2746C20.9611 14.3046 20.4849 13.4137 19.7856 12.7145C19.0863 12.0152 18.1954 11.539 17.2255 11.3461C16.2556 11.1531 15.2503 11.2522 14.3366 11.6306C13.423 12.009 12.6421 12.6499 12.0927 13.4722C11.5433 14.2944 11.2501 15.2611 11.2501 16.25C11.2514 17.5757 11.7786 18.8467 12.716 19.7841C13.6534 20.7215 14.9244 21.2487 16.2501 21.25ZM16.2501 13.75C16.7445 13.75 17.2279 13.8966 17.639 14.1713C18.0501 14.446 18.3705 14.8365 18.5598 15.2933C18.749 15.7501 18.7985 16.2528 18.702 16.7377C18.6056 17.2227 18.3675 17.6681 18.0178 18.0178C17.6682 18.3674 17.2227 18.6055 16.7378 18.702C16.2528 18.7984 15.7502 18.7489 15.2934 18.5597C14.8365 18.3705 14.4461 18.0501 14.1714 17.6389C13.8967 17.2278 13.7501 16.7445 13.7501 16.25C13.751 15.5872 14.0146 14.9519 14.4833 14.4832C14.9519 14.0146 15.5873 13.7509 16.2501 13.75Z" fill="#08C873" />
                                                    <path d="M35.78 24.4625C36.1927 23.9099 36.4684 23.2672 36.5844 22.5873C36.7005 21.9074 36.6537 21.2097 36.4478 20.5514L35.6543 17.9697C35.2817 16.7452 34.5244 15.6734 33.4946 14.9133C32.4648 14.1532 31.2174 13.7453 29.9375 13.75H24.3287C23.9971 13.75 23.6792 13.8817 23.4448 14.1162C23.2103 14.3506 23.0787 14.6685 23.0787 15C23.0787 15.3316 23.2103 15.6495 23.4448 15.8839C23.6792 16.1183 23.9971 16.25 24.3287 16.25H29.9375C30.6823 16.2475 31.4081 16.485 32.0073 16.9274C32.6064 17.3698 33.0471 17.9935 33.2639 18.706L34.0574 21.2867C34.145 21.5713 34.1645 21.8725 34.1145 22.1661C34.0645 22.4597 33.9463 22.7375 33.7694 22.977C33.5925 23.2166 33.3619 23.4114 33.0961 23.5456C32.8302 23.6799 32.5366 23.7499 32.2388 23.75H20.7777C20.7423 23.75 20.7127 23.7672 20.6777 23.7702C20.5937 23.7669 20.5125 23.75 20.4273 23.75H12.5898C11.2007 23.745 9.84705 24.188 8.72972 25.0132C7.61239 25.8385 6.79097 27.0021 6.3874 28.3313L5.45415 31.3625C5.23616 32.0719 5.18764 32.8225 5.31248 33.5541C5.43732 34.2856 5.73204 34.9777 6.17296 35.5746C6.61388 36.1715 7.18869 36.6567 7.85119 36.9911C8.51369 37.3255 9.24541 37.4998 9.98753 37.5H23.0287C23.7708 37.4999 24.5026 37.3256 25.1652 36.9913C25.8277 36.6569 26.4026 36.1717 26.8436 35.5748C27.2845 34.9778 27.5793 34.2858 27.7042 33.5542C27.829 32.8226 27.7805 32.0719 27.5625 31.3625L26.6299 28.3315C26.3936 27.5767 26.0217 26.8713 25.5323 26.25H32.2388C32.9283 26.2532 33.6088 26.0929 34.2244 25.7821C34.8399 25.4714 35.3731 25.0192 35.78 24.4625ZM24.8328 34.089C24.6255 34.3727 24.3539 34.6031 24.0403 34.7615C23.7267 34.9198 23.38 35.0016 23.0287 35H9.98753C9.63653 35 9.29043 34.9176 8.97708 34.7594C8.66373 34.6012 8.39187 34.3718 8.18337 34.0894C7.97487 33.807 7.83555 33.4797 7.77661 33.1337C7.71767 32.7876 7.74077 32.4326 7.84403 32.0971L8.77665 29.0661C9.02442 28.249 9.52925 27.5335 10.2161 27.0262C10.903 26.5188 11.7352 26.2466 12.5892 26.25H20.4267C21.2806 26.2466 22.1128 26.5188 22.7997 27.0262C23.4865 27.5335 23.9914 28.249 24.2392 29.0661L25.1718 32.0971C25.2769 32.4324 25.301 32.7877 25.2421 33.1341C25.1832 33.4804 25.0429 33.8078 24.8328 34.0894V34.089Z" fill="#08C873" />
                                                    <path d="M26.8751 11.25C27.7403 11.25 28.5862 10.9934 29.3057 10.5127C30.0251 10.0319 30.5859 9.34866 30.917 8.54923C31.2482 7.74981 31.3348 6.87014 31.166 6.02148C30.9972 5.17281 30.5805 4.39326 29.9686 3.78141C29.3568 3.16955 28.5772 2.75288 27.7286 2.58407C26.8799 2.41526 26.0002 2.5019 25.2008 2.83303C24.4014 3.16416 23.7181 3.72492 23.2374 4.44438C22.7567 5.16384 22.5001 6.0097 22.5001 6.875C22.5015 8.03489 22.9628 9.14688 23.783 9.96705C24.6032 10.7872 25.7152 11.2486 26.8751 11.25ZM26.8751 5C27.2459 5 27.6084 5.10997 27.9167 5.31599C28.2251 5.52202 28.4654 5.81485 28.6073 6.15747C28.7492 6.50008 28.7864 6.87708 28.714 7.24079C28.6417 7.6045 28.4631 7.9386 28.2009 8.20082C27.9387 8.46304 27.6046 8.64162 27.2408 8.71397C26.8771 8.78631 26.5001 8.74918 26.1575 8.60727C25.8149 8.46535 25.5221 8.22503 25.3161 7.91669C25.11 7.60835 25.0001 7.24584 25.0001 6.875C25.0006 6.37789 25.1983 5.9013 25.5499 5.54979C25.9014 5.19829 26.3779 5.00056 26.8751 5Z" fill="#08C873" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-xl-6">
                                <div className="card">
                                    <div className="card-header dashboard-card-header pb-0 border-0">
                                        <div className="dashboard-card-header__title">
                                            <h4 className="text-black fs-20">Orders Summary</h4>
                                            {/* <p className="fs-13 mb-0 text-black">Lorem ipsum dolor sit amet, consectetur</p> */}
                                        </div>
                                        <div className="card-action card-tabs dashboard-card-header__filters dashboard-date-filters">
                                            {/* <ul className="nav nav-tabs" role="tablist">
                                                <li className="nav-item">
                                                    <a className={`nav-link ${summary.status === 'monthly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getSummary('initial', 'monthly')} style={{ cursor: 'pointer' }} role="tab" aria-selected="true">
                                                        Monthly
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link ${summary.status === 'weekly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getSummary('initial', 'weekly')} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                        Weekly
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link ${summary.status === 'today' ? 'active' : ''}`} data-toggle="tab" onClick={() => getSummary('initial', 'today')} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                        Today
                                                    </a>
                                                </li>
                                            </ul> */}
                                            <ul className="nav nav-tabs" role="tablist">
                                                <li className="nav-item">
                                                    <input type='date' className='form-control' name='start_date' onChange={(e) => handleDates(e.target.value, dates?.end_date)} value={dates?.start_date} max={dates?.end_date} />
                                                </li>
                                                <li>-</li>
                                                <li className="nav-item">
                                                    <input type='date' className='form-control' name='end_date' onChange={(e) => handleDates(dates?.start_date, e.target.value)} value={dates?.end_date} min={dates?.start_date} max={formattedCurrentDate} />
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <div className="tab-pane fade show active orders">
                                                {showInitialLoading ? (
                                                    <>
                                                        <div className="dashboard-skeleton dashboard-skeleton--light dashboard-skeleton-chart" />
                                                        <div className="row mt-4">
                                                            {[1, 2, 3].map((item) => (
                                                                <div className="col-sm-4 mb-md-0 mb-3" key={item}>
                                                                    <div className="p-3 border rounded">
                                                                        <div className="dashboard-skeleton dashboard-skeleton--light dashboard-skeleton-line dashboard-skeleton-line--lg" style={{ width: '42%' }} />
                                                                        <div className="dashboard-skeleton dashboard-skeleton--light dashboard-skeleton-line" style={{ width: '64%', marginTop: '10px' }} />
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="row align-items-center" style={{ marginBottom: '50px', width: 'auto' }}>
                                                            <ReactApexChart options={options5} series={series2} type="donut" />
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-4 mb-md-0 mb-3">
                                                                <div className="p-3 border rounded">
                                                                    <h3 className="fs-32 text-black font-w600 mb-1">{summary?.delivery}</h3>
                                                                    <span className="fs-18">Delivery<br />Orders</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-4 mb-md-0 mb-3">
                                                                <div className="p-3 border rounded">
                                                                    <h3 className="fs-32 text-black font-w600 mb-1">{summary?.pickuped}</h3>
                                                                    <span className="fs-18">Pickup<br />Orders</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <div className="p-3 border rounded">
                                                                    <h3 className="fs-32 text-black font-w600 mb-1">{summary?.cancelled}</h3>
                                                                    <span className="fs-18">Cancelled<br />Orders</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                            {/* <div className="tab-pane fade" id="Weekly">
                                            <div className="row align-items-center">
                                                <div className="col-sm-6">
                                                    <div id="radialBar2" className="orderChart"></div>
                                                </div>
                                                <div className="col-sm-6 mb-sm-0 mb-3 text-center">
                                                    <h3 className="fs-28 text-black font-w600">$150,002.00</h3>
                                                    <span className="mb-3 d-block">from $400,000.00</span>
                                                    <p className="fs-14">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do </p>
                                                    <a href="post-details.html" className="btn btn-primary light btn-rounded">More Details</a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4 mb-md-0 mb-3">
                                                    <div className="p-3 border rounded">
                                                        <h3 className="fs-32 text-black font-w600 mb-1">30</h3>
                                                        <span className="fs-18">On Delivery</span>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 mb-md-0 mb-3">
                                                    <div className="p-3 border rounded">
                                                        <h3 className="fs-32 text-black font-w600 mb-1">55</h3>
                                                        <span className="fs-18">pickuped</span>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="p-3 border rounded">
                                                        <h3 className="fs-32 text-black font-w600 mb-1">9</h3>
                                                        <span className="fs-18">Canceled</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="Today">
                                            <div className="row align-items-center">
                                                <div className="col-sm-6">
                                                    <div id="radialBar3" className="orderChart"></div>
                                                </div>
                                                <div className="col-sm-6 mb-sm-0 mb-3 text-center">
                                                    <h3 className="fs-28 text-black font-w600">$856,005.56</h3>
                                                    <span className="mb-3 d-block">from $800,000.00</span>
                                                    <p className="fs-14">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do </p>
                                                    <a href="post-details.html" className="btn btn-primary light btn-rounded">More Details</a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4 mb-md-0 mb-3">
                                                    <div className="p-3 border rounded">
                                                        <h3 className="fs-32 text-black font-w600 mb-1">45</h3>
                                                        <span className="fs-18">On Delivery</span>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 mb-md-0 mb-3">
                                                    <div className="p-3 border rounded">
                                                        <h3 className="fs-32 text-black font-w600 mb-1">90</h3>
                                                        <span className="fs-18">pickuped</span>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="p-3 border rounded">
                                                        <h3 className="fs-32 text-black font-w600 mb-1">3</h3>
                                                        <span className="fs-18">Canceled</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="card">
                                    <div className="card-header d-sm-flex d-block pb-0 border-0">
                                        <div className="mr-auto pr-3">
                                            <h4 className="text-black fs-20">Revenue</h4>
                                            {/* <p className="fs-13 mb-0 text-black">Lorem ipsum dolor sit amet, consectetur</p> */}
                                        </div>
                                        {/* <div className="dropdown mt-sm-0 mt-3">
                                        <button type="button" className="btn btn-primary light btn-rounded dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                            Monthly
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right">
                                            <a className="dropdown-item" href="javascript:void(0);">Link 1</a>
                                            <a className="dropdown-item" href="javascript:void(0);">Link 2</a>
                                            <a className="dropdown-item" href="javascript:void(0);">Link 3</a>
                                        </div>
                                    </div> */}
                                    </div>
                                    <div className="card-body" id="user-activity">
                                        <div className="d-flex flex-wrap mb-4">
                                            {/* <div className="mr-auto mb-2 pr-3 d-flex align-items-center">
                                            <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="3.54545" height="26" rx="1.77273" fill="#EA7A9A" />
                                                <rect x="7.09088" y="7.09082" width="3.54545" height="18.9091" rx="1.77273" fill="#EA7A9A" />
                                                <rect x="14.1819" y="17.7271" width="3.54545" height="8.27273" rx="1.77273" fill="#EA7A9A" />
                                                <rect x="21.2727" y="3.54541" width="3.54545" height="22.4545" rx="1.77273" fill="#EA7A9A" />
                                            </svg>
                                            <div className="ml-3">
                                                <p className="fs-12 mb-1">Income</p>
                                                <span className="fs-22 text-black font-w600">${Intl.NumberFormat('en-US').format(cardsValues?.revenue)}</span>
                                            </div>
                                        </div> */}
                                            {/* <div className="card-action revenue-tabs">
                                            <ul className="nav nav-tabs" role="tablist">
                                                <li className="nav-item">
                                                    <a className="nav-link active" data-toggle="tab" href="#user" role="tab" aria-selected="true">
                                                        All Food
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-toggle="tab" href="#bounce" role="tab" aria-selected="false">
                                                        Food
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-toggle="tab" href="#session-duration" role="tab" aria-selected="false">
                                                        Beverages
                                                    </a>
                                                </li>
                                            </ul>
                                        </div> */}
                                        </div>
                                        <div className="tab-content" id="myTabContent">
                                            <div className="tab-pane fade show active" id="user" role="tabpanel" style={{ height: '300px' }}>
                                                {showInitialLoading ? (
                                                    <div className="dashboard-skeleton dashboard-skeleton--light dashboard-skeleton-chart" />
                                                ) : (
                                                    <Line options={options2} data={data} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-9 col-xxl-8">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card">
                                            <div className="card-header dashboard-card-header pb-0 border-0">
                                                <div className="dashboard-card-header__title">
                                                    <h4 className="text-black fs-20">Orders List</h4>
                                                    {/* <p className="fs-13 mb-0 text-black">Lorem ipsum dolor sit amet, consectetur</p> */}
                                                </div>
                                                <div className="card-action card-tabs dashboard-card-header__filters">
                                                    <ul className="nav nav-tabs" role="tablist">
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${orders.status === 'today' ? 'active' : ''}`} data-toggle="tab" onClick={() => getOrders('initial', 'today', trendItems.status)} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                Today
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${orders.status === 'weekly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getOrders('initial', 'weekly', trendItems.status)} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                Weekly
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${orders.status === 'monthly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getOrders('initial', 'monthly', trendItems.status)} style={{ cursor: 'pointer' }} role="tab" aria-selected="true">
                                                                Monthly
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="tab-content orders">
                                                    <div className="tab-pane fade show active" id="tab1">
                                                        {/* <div id="chartTimeline"></div> */}
                                                        {/* <div className="card-body"> */}
                                                        {orders.list.length > 0 ? orders.list.map(elem =>
                                                            <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                                <span className="num">#{elem?.order_id}</span>
                                                                <div className="mr-auto pr-3">
                                                                    {/* <h2 className="text-black fs-14">{elem?.items[0]?.item_name}{elem?.items?.length > 1 ? <span style={{ color: 'grey', fontSize: '13px', display: 'block' }}>+{elem?.items?.length - 1}</span> : ''}</h2> */}
                                                                    <h2 className="text-black fs-14">{(elem?.items || []).map(el => { return el?.item_name }).filter(Boolean).join(', ') || 'Items unavailable'}</h2>
                                                                    <span className="text-black font-w600 d-inline-block mr-3">{resto?.currency_symbol ?? '$'}{elem?.items_total} </span>
                                                                    <span className="fs-14">Order Date : {moment(orderMillis(elem)).format('MM/DD/YYYY h:mm:ss A')}</span>
                                                                </div>
                                                                {elem?.items?.[0]?.item_image && (
                                                                    <img src={elem.items[0].item_image} alt="" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }} />
                                                                )}
                                                            </div>
                                                        ) : <h6>No orders available</h6>}
                                                        {/* <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                            <span className="num">#2</span>
                                                            <div className="mr-auto pr-3">
                                                                <a href="post-details.html"><h2 className="text-black fs-14">Watermelon juice with ice</h2></a>
                                                                <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                            </div>
                                                            <img src="images/menus/10.png" alt="" width="60" className="rounded" />
                                                        </div>
                                                        <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                            <span className="num">#3</span>
                                                            <div className="mr-auto pr-3">
                                                                <a href="post-details.html"><h2 className="text-black fs-14">Chicken curry special with cucumber</h2></a>
                                                                <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                            </div>
                                                            <img src="images/menus/11.png" alt="" width="60" className="rounded" />
                                                        </div>
                                                        <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                            <span className="num">#4</span>
                                                            <div className="mr-auto pr-3">
                                                                <a href="post-details.html"><h2 className="text-black fs-14">Italiano Pizza With Garlic</h2></a>
                                                                <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                            </div>
                                                            <img src="images/menus/12.png" alt="" width="60" className="rounded" />
                                                        </div>
                                                        <div className="d-flex tr-row align-items-center">
                                                            <span className="num">#5</span>
                                                            <div className="mr-auto pr-3">
                                                                <a href="post-details.html"><h2 className="text-black fs-14">Tuna Soup spinach with himalaya salt</h2></a>
                                                                <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                            </div>
                                                            <img src="images/menus/9.png" alt="" width="60" className="rounded" />
                                                        </div> */}
                                                        {/* </div> */}
                                                    </div>
                                                    {/* <div className="tab-pane fade" id="tab2">
                                                    <div id="chartTimeline2"></div>
                                                </div>
                                                <div className="tab-pane fade" id="tab3">
                                                    <div id="chartTimeline3"></div>
                                                </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-xl-8 col-xxl-12 col-lg-8">
                                    <div className="card">
                                        <div className="card-header border-0 pb-0">
                                            <h4 className="text-black fs-20 mb-0">Transactions Summary</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-6 mb-sm-0 mb-3">
                                                    <div className="media align-items-center">
                                                        <div className="d-inline-block mr-3 position-relative donut-chart-sale2" >
                                                            <ReactApexChart options={options3} series={[parseInt((cardsValues.sucOrders / cardsValues.orders) * 100)]} type="radialBar" />
                                                        </div>
                                                        <div>
                                                            <h4 className="fs-28 font-w600 text-black mb-0">{cardsValues.sucOrders}</h4>
                                                            <span>Succesfull Order</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="media align-items-center">
                                                        <div className="d-inline-block mr-3 position-relative donut-chart-sale2">
                                                            <ReactApexChart options={options3} series={[parseInt((cardsValues.unsucOrders / cardsValues.orders) * 100)]} type="radialBar" />
                                                        </div>
                                                        <div>
                                                            <h4 className="fs-28 font-w600 text-black mb-0">{cardsValues.unsucOrders}</h4>
                                                            <span>Unsuccesfull Order</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div > */}
                                    {/* <div className="col-xl-4 col-xxl-12 col-lg-4" >
                                        <div className="card">
                                            <div className="card-header dashboard-card-header border-0 pb-0">
                                                <div className="dashboard-card-header__title">
                                                    <h4 className="text-black fs-20 mb-0">Average</h4>
                                                </div>
                                                <div className="card-action card-tabs dashboard-card-header__filters">
                                                    <ul className="nav nav-tabs" role="tablist">
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${average.order === 'weekly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getAverages('initial', 'weekly', average.items, average.amounts, 'check 1')} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                Weekly
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${average.order === 'monthly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getAverages('initial', 'monthly', average.items, average.amounts, 'check 1')} style={{ cursor: 'pointer' }} role="tab" aria-selected="true">
                                                                Monthly
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${average.order === 'yearly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getAverages('initial', 'yearly', average.items, average.amounts, 'check 1')} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                Yearly
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="d-flex align-items-end">
                                                    <div>
                                                        <h4 className="fs-28 font-w600 text-black mb-0">{getAverageOrder()}</h4>
                                                        <span>Order</span>
                                                    </div>
                                                        <Bar options={options4} data={data2} className="lineChart" />
                                </div>
                            </div>
                        </div>
                    </div> */}
                                    <div className="col-xl-12 col-xxl-12 col-lg-12" >
                                        <div className="card">
                                            <div className="card-header dashboard-card-header border-0 pb-0">
                                                <div className="dashboard-card-header__title">
                                                    <h4 className="text-black fs-20 mb-0">Average</h4>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                {showInitialLoading ? (
                                                    <div className="dashboard-widget-skeleton">
                                                        <div>
                                                            <div className="dashboard-skeleton dashboard-skeleton--light dashboard-skeleton-line dashboard-skeleton-line--lg" style={{ width: '48%' }} />
                                                            <div className="dashboard-skeleton dashboard-skeleton--light dashboard-skeleton-line" style={{ width: '32%', marginTop: '10px' }} />
                                                        </div>
                                                        <div className="dashboard-skeleton dashboard-skeleton--light dashboard-skeleton-chart dashboard-skeleton-chart--compact" />
                                                    </div>
                                                ) : (
                                                    <div className="dashboard-average-combined">
                                                        <div className="dashboard-average-panel">
                                                            <div className="dashboard-average-panel__header">
                                                                
                                                                <div className="card-action card-tabs dashboard-card-header__filters">
                                                                    <ul className="nav nav-tabs" role="tablist">
                                                                        <li className="nav-item">
                                                                            <button className={`nav-link ${average.items === 'weekly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getAverages2([
                                                                                    { key: 'orders', period: 'weekly' },
                                                                                    { key: 'items', period: 'weekly' },
                                                                                    { key: 'amounts', period: 'weekly' },
                                                                                    ])} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                                Weekly
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <button className={`nav-link ${average.items === 'monthly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getAverages2([
                                                                                { key: 'orders', period: 'monthly' },
                                                                                { key: 'items', period: 'monthly' },
                                                                                { key: 'amounts', period: 'monthly' }
                                                                            ])} style={{ cursor: 'pointer' }} role="tab" aria-selected="true">
                                                                                Monthly
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <button className={`nav-link ${average.items === 'yearly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getAverages2([
                                                                                { key: 'orders', period: 'yearly' },
                                                                                { key: 'items', period: 'yearly' },
                                                                                { key: 'amounts', period: 'yearly' }
                                                                            ])} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                                Yearly
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-end">
                                                                <div>
                                                                    <h4 className="fs-28 font-w600 text-black mb-0">{getAverageOrder2()}</h4>
                                                                    <span>Item</span>
                                                                </div>
                                                                <Bar options={options4} data={data3} className="lineChart" />
                                                                
                                                            </div>
                                                            <hr className="my-4" />
                                                            <div className="d-flex align-items-end">
                                                                <div>
                                                                    <h4 className="fs-28 font-w600 text-black mb-0">{resto?.currency_symbol ?? '$'} {Intl.NumberFormat('en-US').format(getAverageOrder3())}</h4>
                                                                    <span>Amount</span>
                                                                </div>
                                                            <Bar options={options4} data={data4} className="lineChart" />
                                                            </div>
                                                        </div>
                                                    
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div >
                                </div >
                            </div >
                            <div className="col-xl-3 col-xxl-4">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card trending-menus">
                                            <div className="card-header dashboard-card-header pb-0 border-0">
                                                <div className="dashboard-card-header__title">
                                                    <h4 className="text-black fs-20">Trending Items</h4>
                                                    {/* <p className="fs-13 mb-0 text-black">Lorem ipsum dolor sit amet, consectetur</p> */}
                                                </div>
                                                <div className="card-action card-tabs dashboard-card-header__filters">
                                                    <ul className="nav nav-tabs" role="tablist">
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${trendItems.status === 'today' ? 'active' : ''}`} data-toggle="tab" onClick={() => getOrders('initial', orders.status, 'today')} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                Today
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${trendItems.status === 'weekly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getOrders('initial', orders.status, 'weekly')} style={{ cursor: 'pointer' }} role="tab" aria-selected="false">
                                                                Weekly
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${trendItems.status === 'monthly' ? 'active' : ''}`} data-toggle="tab" onClick={() => getOrders('initial', orders.status, 'monthly')} style={{ cursor: 'pointer' }} role="tab" aria-selected="true">
                                                                Monthly
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="card-body orders">
                                                {trendItems?.list?.length > 0 ? trendItems?.list?.map((elem, index) =>
                                                    <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                        <span className="num">#{index + 1}</span>
                                                        <div className="mr-auto pr-3">
                                                            <a href="post-details.html"><h2 className="text-black fs-14">{elem.item_name}</h2></a>
                                                            {/* <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> */}
                                                            <span className="fs-14">Order {elem.count}x</span>
                                                        </div>
                                                        <img src={elem.item_image} alt="" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }} />
                                                    </div>
                                                ) : <h6>No trending items available</h6>}
                                                {/* <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                <span className="num">#2</span>
                                                <div className="mr-auto pr-3">
                                                    <a href="post-details.html"><h2 className="text-black fs-14">Watermelon juice with ice</h2></a>
                                                    <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                </div>
                                                <img src="images/menus/10.png" alt="" width="60" className="rounded" />
                                            </div>
                                            <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                <span className="num">#3</span>
                                                <div className="mr-auto pr-3">
                                                    <a href="post-details.html"><h2 className="text-black fs-14">Chicken curry special with cucumber</h2></a>
                                                    <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                </div>
                                                <img src="images/menus/11.png" alt="" width="60" className="rounded" />
                                            </div>
                                            <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                                <span className="num">#4</span>
                                                <div className="mr-auto pr-3">
                                                    <a href="post-details.html"><h2 className="text-black fs-14">Italiano Pizza With Garlic</h2></a>
                                                    <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                </div>
                                                <img src="images/menus/12.png" alt="" width="60" className="rounded" />
                                            </div>
                                            <div className="d-flex tr-row align-items-center">
                                                <span className="num">#5</span>
                                                <div className="mr-auto pr-3">
                                                    <a href="post-details.html"><h2 className="text-black fs-14">Tuna Soup spinach with himalaya salt</h2></a>
                                                    <span className="text-black font-w600 d-inline-block mr-3">$5.6 </span> <span className="fs-14">Order 89x</span>
                                                </div>
                                                <img src="images/menus/9.png" alt="" width="60" className="rounded" />
                                            </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >
                </div >
            </div >
        </>
    )
}

export default Dashboard
